import { Collapse, Row, Col, Tooltip, Input, Form } from "antd";
import React, { createRef, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CollapseComponent } from "../../../components/Collapse";
import ConversionStatisticsStore from "../../../DataStores/ConversionStatisticsStore";
import { inject, observer } from "mobx-react";

import "../../../styles/components.scss";
import { dataSuperior, dataSuperior0 } from "../../../utils/Utils";
import { toJS } from "mobx";
const { Panel } = Collapse;

const ConversionStatistics = ({ ToolStore, displayAll }) => {
  const [form] = Form.useForm();

  const [display, setDisplay] = useState(false);
  useEffect(() => {
    form.setFieldsValue(ConversionStatisticsStore.toFormatJson());
    if (
      (toJS(ConversionStatisticsStore.data)[0].value[0].display != -1 &&
        toJS(ConversionStatisticsStore.data)[0].value[0].display) ||
      (toJS(ConversionStatisticsStore.data)[0].value[1].display != -1 &&
        toJS(ConversionStatisticsStore.data)[0].value[1].display)
    ) {
      setDisplay(true);
    } else {
      setDisplay(false || displayAll);
    }
  }, [
    ConversionStatisticsStore.data,
    ToolStore.numbersToTest,
    ToolStore.conditions,
  ]);

  const toGetElement = (first, second) => {
    var element = ConversionStatisticsStore.getData()[0]
      .value.filter((a) => a.fieldName == first)[0]
      .value.filter((b) => b.fieldName == second)[0];
    return element;
  };

  const onChange = (first, e) => {
    if (!ConversionStatisticsStore.changed[first]) {
      var json = form.getFieldsValue();
      json[first] = parseFloat(e.nativeEvent.data);
      form.setFieldsValue(json);
    }
    const c = { ...ConversionStatisticsStore.changed };
    c[first] = true;
    ConversionStatisticsStore.setChanged(c);
  };

  const onBlur = (ev, id) => {
    if (ev.target.value == "") {
      var json = form.getFieldsValue();
      json[id] = ConversionStatisticsStore.defaultsValues[id];
      form.setFieldsValue(json);
      const c = { ...ConversionStatisticsStore.changed };

      c[id] = false;
      ConversionStatisticsStore.setChanged(c);
    }
  };

  const elements = () => {
    const rateLead = ConversionStatisticsStore.getData()[0].value[0];
    const caseAcceptance = ConversionStatisticsStore.getData()[0].value[1];
    if (displayAll) {
      return (
        <Row>
          <Col xl={10} md={24}>
            <Row>
              <Col xl={2} md={2}>
                <Tooltip
                  color="#EBEBEA"
                  fontFamily="Gotham"
                  fontSize="20px"
                  style={{ textColor: "#6a6e80" }}
                  placement="rightTop"
                  title={<FormattedMessage id="rateLeadTooltip" />}
                >
                  <img src="/images/icons/bull.svg" />
                </Tooltip>
              </Col>
              <Col md={12} xl={14}>
                <span
                  className="roi--label-section"
                  style={{ marginTop: "10px" }}
                >
                  <FormattedMessage id="rateLead" />
                </span>
              </Col>
              <Col md={6} xl={8}>
                <Form.Item
                  name="rateLead"
                  rules={[{ validator: dataSuperior }]}
                >
                  <Input
                    type="number"
                    suffix={rateLead.suffix && rateLead.suffix}
                    prefix={rateLead.prefix && rateLead.prefix}
                    className={
                      !ConversionStatisticsStore.changed.rateLead &&
                      "roi--input-default"
                    }
                    onChange={(e) => onChange("rateLead", e)}
                    onBlur={(e) => onBlur(e, "rateLead")}
                  ></Input>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xl={2} md={0} xs={0}></Col>{" "}
          <Col xl={10} md={24} xs={24}>
            <Row>
              <Col xl={2} md={2}>
                <Tooltip
                  color="#EBEBEA"
                  fontFamily="Gotham"
                  fontSize="20px"
                  style={{ textColor: "#6a6e80" }}
                  placement="rightTop"
                  title={<FormattedMessage id="caseAcceptanceTooltip" />}
                >
                  <img src="/images/icons/bull.svg" />
                </Tooltip>
              </Col>
              <Col md={12} xl={14}>
                <span
                  className="roi--label-section"
                  style={{ marginTop: "10px" }}
                >
                  <FormattedMessage id="caseAcceptance" />
                </span>
              </Col>
              <Col md={6} xl={8}>
                <Form.Item
                  name="caseAcceptance"
                  rules={[{ validator: dataSuperior }]}
                >
                  <Input
                    type="number"
                    suffix={caseAcceptance.suffix && caseAcceptance.suffix}
                    prefix={caseAcceptance.prefix && caseAcceptance.prefix}
                    onChange={(e) => onChange("caseAcceptance", e)}
                    onBlur={(e) => onBlur(e, "caseAcceptance")}
                    className={
                      !ConversionStatisticsStore.changed.caseAcceptance &&
                      "roi--input-default"
                    }
                  ></Input>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }
    if (
      (rateLead.display != -1 && rateLead.display) ||
      (caseAcceptance.display != -1 && caseAcceptance.display)
    ) {
      return (
        <Row>
          {rateLead.display != -1 && rateLead.display && (
            <>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="rateLeadTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="rateLead" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="rateLead"
                      rules={[{ validator: dataSuperior }]}
                    >
                      <Input
                        type="number"
                        suffix={rateLead.suffix && rateLead.suffix}
                        prefix={rateLead.prefix && rateLead.prefix}
                        className={
                          !ConversionStatisticsStore.changed.rateLead &&
                          "roi--input-default"
                        }
                        onChange={(e) => onChange("rateLead", e)}
                        onBlur={(e) => onBlur(e, "rateLead")}
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>{" "}
            </>
          )}{" "}
          {caseAcceptance.display != -1 && caseAcceptance.display && (
            <Col xl={10} md={24} xs={24}>
              <Row>
                <Col xl={2} md={2}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                    title={<FormattedMessage id="caseAcceptanceTooltip" />}
                  >
                    <img src="/images/icons/bull.svg" />
                  </Tooltip>
                </Col>
                <Col md={12} xl={14}>
                  <span
                    className="roi--label-section"
                    style={{ marginTop: "10px" }}
                  >
                    <FormattedMessage id="caseAcceptance" />
                  </span>
                </Col>
                <Col md={6} xl={8}>
                  <Form.Item
                    name="caseAcceptance"
                    rules={[{ validator: dataSuperior }]}
                  >
                    <Input
                      type="number"
                      suffix={caseAcceptance.suffix && caseAcceptance.suffix}
                      prefix={caseAcceptance.prefix && caseAcceptance.prefix}
                      onChange={(e) => onChange("caseAcceptance", e)}
                      onBlur={(e) => onBlur(e, "caseAcceptance")}
                      className={
                        !ConversionStatisticsStore.changed.caseAcceptance &&
                        "roi--input-default"
                      }
                    ></Input>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      <Form
        form={form}
        onChange={() =>
          ConversionStatisticsStore.toUpdateConversion(form.getFieldsValue())
        }
      >
        {(display || displayAll) && (
          <CollapseComponent
            style={{ marginBottom: "2vh", marginTop: "2vh" }}
            headerText={<FormattedMessage id="conversionStatistics" />}
            classNameHeader="roi--collapse-header-green"
            content={
              ConversionStatisticsStore.data != null && <>{elements()}</>
            }
          ></CollapseComponent>
        )}
      </Form>
    </>
  );
};

export default inject("ToolStore")(observer(ConversionStatistics));
